export default "__VITE_ASSET__CrD3XTJk__"